import {Component, Injector, OnInit} from '@angular/core';
import {CupomService} from '../../../core/services/cupom.service';
import {PropostaService} from '../../../core/services/proposta.service';
import {Router} from '@angular/router';
import {CepService} from '../../../core/services/cep.service';
import {ToastrService} from 'ngx-toastr';
import {CategoriaPlanoService} from '../../../core/services/categoria_plano.service';
import {AppComponent} from '../../../app.component';
import {Meta, Title} from '@angular/platform-browser';
import {ProdutoService} from '../../../core/services/produto.service';
import {PropostaComponent} from '../proposta';
import {HOME} from '../../../app.constants';
import {RdService} from '../../../core/services/rd.service';
import {DeviceDetectorService} from 'ngx-device-detector';
import {TYPE_META} from '../../../core/constants/meta_title.constant';

@Component({
  selector: 'app-confirmacao-sales',
  templateUrl: './confirmacao-sales.component.html',
  styleUrls: ['./confirmacao-sales.component.sass']
})
export class ConfirmacaoSalesComponent extends PropostaComponent implements OnInit {


  constructor(
      protected injector: Injector,
      public cupomService: CupomService,
      public propostaService: PropostaService,
      public router: Router,
      public cepService: CepService,
      public toast: ToastrService,
      public categoriaPlanoService: CategoriaPlanoService,
      public appComponent: AppComponent,
      public titleService: Title,
      public meta: Meta,
      public produtoService: ProdutoService,
      public rdService: RdService,
      public deviceService: DeviceDetectorService,
  ) {
    super(injector);
  }

  async ngOnInit() {
    this.setMetaTitle(TYPE_META.CARRINHO.CONFIRMACAO_SALES);
    const proposta = await this.getPropostaParaStorage();
    if (proposta) {
      const email = proposta.email || null;
      if (email) {
        await this.rdService.carrinhoSucessoCompra(email);
      }
    }
  }

  goToHome() {
    window.open(HOME, '_top');
  }

}
